import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import moment from "moment";
import {FullTableByScroll} from "components";
import {AllStatusesEnum, EscortAppPatientEnum, GoogleMapComponent, howMuchIsLeft} from "fragments";
import {dispatchBoarBody, dispatchBoardHead, emptyState, renderSelectTrip} from "./constants";
import {AddSelectedTrip} from "./fragments";
import {MainHeader} from "./fragments/mainHeader";
import {CalendarAndTotals} from "./fragments/calendarAndTotals";
import {FindSuccess, newDateWithoutUtc, setDateOfTime, useModal, sortLegs} from "utils";
import {httpRequestsOnSuccessActions, legsActions, vehiclesActions} from "store";
import {AddTrip} from "./fragments/addTrip";

const ACTION_TYPE = "GET_LEGS";
const ACTION_TYPE_GET_LOCATIONS = "GET_VEHICLES_LOCATIONS";
const GET_VEHICLES_LOCATIONS_SUCCESS = "GET_VEHICLES_LOCATIONS_SUCCESS";


export const DispatchBoard = () => {
    const legsList = useSelector((state) => state.legs?.legsList);
    const vehiclesLocations = useSelector((state) => state.vehicles?.vehiclesLocations);

    const [currentItem, setCurrentItem] = useState(null);
    const [legLocation, setLegLocation] = useState(null);
    const {control, watch} = useForm();
    const {control: controlDate, watch: watchDate} = useForm({
        defaultValues: {
            serviceDate: moment().format("YYYY-MM-DD")
        }
    });
    const dispatch = useDispatch()
    const location = useLocation();
    const intervalRef = useRef(null);
    const intervalVehicleLocRef = useRef(null);
    const successLocations = FindSuccess(ACTION_TYPE_GET_LOCATIONS);

    const {openModal, close} = useModal();
    const info = location?.state;
    const {pathname} = location;
    const mapView = Boolean(watch('mapView'));
    const duplicate = Boolean(watch('duplicate'));
    const serviceDate = info?.serviceDate || watchDate('serviceDate');

    const renderParams = () => {
        return {
            statuses: info?.statuses,
            serviceDate: newDateWithoutUtc(serviceDate),
        };
    }

    const getLegInfo = (noLoad) => {
        const params = renderParams();
        dispatch(legsActions.getLegs(params, noLoad))
        // dispatch(legsActions.getLegsTotals({serviceDate: params?.serviceDate}))
    }

    const getVehiclesLocations = () => {
        if (mapView) {
            dispatch(vehiclesActions.getVehiclesLocations())
        }
    }

    const handleAfterSuccess = () => {
        getLegInfo(true);
        close();
    }

    useEffect(() => {
        if (successLocations?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_GET_LOCATIONS));
        }
    }, [successLocations]);

    useEffect(() => {
        const params = {
            status: AllStatusesEnum.ACTIVE,
        };
        dispatch(vehiclesActions.getVehicles(params))
    }, []);

    useEffect(() => {
        getLegInfo();
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            getLegInfo(true);
        }, 15000);

        return () => clearInterval(intervalRef.current);
    }, [info?.statuses, serviceDate]);

    useEffect(() => {
        dispatch(vehiclesActions.getVehiclesLocations())
    }, [])

    useEffect(() => {
        if (!mapView) {
            setLegLocation(null);
            dispatch({
                type: GET_VEHICLES_LOCATIONS_SUCCESS,
                payload: null
            })
        } else {
            if (currentItem) {
                const item = currentItem;
                const params = {
                    legStatus: item?.status,
                    vehicleId: item?.vehicle?._id || item?.vehicle?.id,
                    dropOff: {
                        lat: item?.dropOff?.address?.lat,
                        lng: item?.dropOff?.address?.lng,
                        formattedAddress: item?.dropOff?.address?.formattedAddress,
                    },
                    pickUp: {
                        lat: item?.pickUp?.address?.lat,
                        lng: item?.pickUp?.address?.lng,
                        formattedAddress: item?.pickUp?.address?.formattedAddress,
                    },
                };
                if (item?.status === EscortAppPatientEnum.OPEN && item?.pickUp?.scheduledTime) {
                    params.pickUpDate = item?.pickUp?.scheduledTime;
                }

                setLegLocation({...params, renderTrigger: Date.now()});
            }

            getVehiclesLocations();

            // if (intervalVehicleLocRef.current) clearInterval(intervalVehicleLocRef.current);
            // intervalVehicleLocRef.current = setInterval(() => {
            //     getVehiclesLocations();
            // }, 15000);

            return () => clearInterval(intervalVehicleLocRef.current);
        }
    }, [mapView]);


    const onChangeTimes = (item, ev, path, originalName) => {
        const params = {
            [ev?.target?.name]: setDateOfTime(item?.serviceDate, ev?.target?.value)
        }

        const updatedList = legsList?.legs?.map((leg) => {
            if (leg?.id === item?.id) {
                const params = {
                    ...leg,
                }
                params[path][originalName] = setDateOfTime(item?.serviceDate, ev?.target?.value);

                if (path === 'pickUp' && originalName === 'pickupTime') {
                    if (!ev?.target?.value) {
                        params.dropOff.mileage = 0;
                        params.status = EscortAppPatientEnum.ARRIVED;
                    } else {
                        params.status = EscortAppPatientEnum.EN_ROUT;
                    }
                }

                if (path === 'dropOff' && originalName === 'arrivedTime') {
                    if (!ev?.target?.value) {
                        params.dropOff.mileage = 0;
                        params.status = EscortAppPatientEnum.EN_ROUT;
                    } else {
                        params.status = EscortAppPatientEnum.COMPLETED;
                    }
                }
                return params
            }
            return leg;
        })

        dispatch(legsActions.editLegList({legs: updatedList, count: legsList?.count}))
        dispatch(legsActions.legAssignOrChangeData(item?.id, params, false, renderParams()))
    }

    const handleClickToRow = (item) => {
        if (currentItem?.id === item?.id) {
            setCurrentItem(null);
            setLegLocation(null)
        } else {
            if (item?.status) {
                const params = {
                    legStatus: item?.status,
                    vehicleId: item?.vehicle?._id || item?.vehicle?.id,
                    dropOff: {
                        lat: item?.dropOff?.address?.lat,
                        lng: item?.dropOff?.address?.lng,
                        formattedAddress: item?.dropOff?.address?.formattedAddress,
                    },

                    pickUp: {
                        lat: item?.pickUp?.address?.lat,
                        lng: item?.pickUp?.address?.lng,
                        formattedAddress: item?.pickUp?.address?.formattedAddress,
                    },
                }
                if (item?.status === EscortAppPatientEnum.OPEN && item?.pickUp?.scheduledTime) {
                    params.pickUpDate = item?.pickUp?.scheduledTime
                }

                setLegLocation({...params, renderTrigger: Date.now()})
                setCurrentItem(item)
            }
        }
    }

    const addTrip = () => {
        openModal(
            <AddSelectedTrip
                afterSuccess={handleAfterSuccess}
                requestParams={renderParams()}
            />, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 579,
                dontClose: true,
            })

    }

    const handleDoubleClickRow = (item) => {
        const tripDetails = renderSelectTrip.find((r) => r?.tripDetails?.includeLegTypes?.includes(item.type))?.tripDetails;

        openModal(
            <AddTrip
                tripId={item?.trip}
                tripDetails={tripDetails}
                afterSuccess={handleAfterSuccess}
                requestParams={renderParams()}
            />, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 1325,
                dontClose: true,
            })
    }


    const sortedList = sortLegs(legsList?.legs || [], info?.sortType, info?.orderType, duplicate);

    return (
        <div className='dispatch-board-page'>
            <div className="main-info-fragment-wrapper">
                <MainHeader
                    pathname={pathname}
                    control={control}
                    serviceDate={serviceDate}
                    addTrip={legsList?.legs?.length ? addTrip : ''}
                    mapView={mapView}
                />

                <div className="main-info-fragment-content">
                    <div style={{display: 'flex', gap: 16}}>
                        <div style={{width: '100%', overflow: 'auto'}}>
                            <FullTableByScroll
                                tableFiltersBox={(list) => <CalendarAndTotals controlDate={controlDate} list={list}/>}
                                head={dispatchBoardHead()}
                                body={dispatchBoarBody({onChangeTimes, requestParams: renderParams()})}
                                list={sortedList}
                                loadingType={ACTION_TYPE}
                                handleClick={handleClickToRow}
                                onDoubleClick={handleDoubleClickRow}
                                getCellForStyle={(item) => {
                                    if (item?.status === EscortAppPatientEnum.OPEN) {
                                        const howMuch = howMuchIsLeft(item?.pickUp?.scheduledTime);
                                        return {
                                            backgroundColor: howMuch === 15 ?
                                                '#FFEBEE' : howMuch === 30 ? '#FFFAE5' : ''
                                        };
                                    }
                                }}
                                getRowForStyle={(item) => {
                                    return {
                                        border: currentItem?.id === item?.id ? '2px solid #000 ' : '',
                                        // marginBottom: currentItem?.id === item?.id ? 0 : '-1px'
                                    }
                                }}
                                emptyState={emptyState(addTrip)}
                            />
                        </div>

                        {(mapView) &&
                            <div style={{marginTop: 16, width: '100%', height: 'inherit'}}>
                                <GoogleMapComponent
                                    key={legLocation?.vehicleId || 'default'}
                                    vehiclesLocations={vehiclesLocations}
                                    legLocation={legLocation}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

